import React from 'react'
import {Attachments} from '@components/common/base/attachments/attachments'

export interface SharedAttachmentsProps {
  files: File[]
  onRemove: (i: number) => void
  className?: string
}

export const SharedAttacments = (props: SharedAttachmentsProps) => {
  return <Attachments {...props} />
}
